var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.message.shuffled)?_c('li',[_vm._v("Shuffled deck.")]):_vm._e(),_c('li',[_vm._v("Drew card.")])])}
var staticRenderFns = []

export { render, staticRenderFns }